// Internal Config
// Client Config when Remote Config is disabled
export function adaptDisableAnalyticsForAutoPlayTrailersClientConfig(config) {
    return config;
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptDisableAnalyticsForAutoPlayTrailersRemoteConfigSplit(config) {
    var _config_clientConfig;
    return {
        adobe: Boolean((_config_clientConfig = config.clientConfig) === null || _config_clientConfig === void 0 ? void 0 : _config_clientConfig.adobe)
    };
}

//# sourceMappingURL=disable-analytics-for-autoplay-trailers-adapter.js.map